import Sidebar from './Sidebar.jsx';
import BottomTabBar from './BottomTabBar.jsx';
import EntitySelector from './EntitySelector.jsx';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-slate-50 flex">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        {/* Mobile-only header with entity selector — desktop has it in sidebar. */}
        <header
          className="lg:hidden sticky phonels:static top-0 z-10 bg-white"
          style={{ paddingLeft: 'env(safe-area-inset-left)', paddingRight: 'env(safe-area-inset-right)' }}
        >
          <EntitySelector />
        </header>
        <main className="flex-1 min-w-0 pb-[calc(5rem+env(safe-area-inset-bottom))] lg:pb-6 pt-4 pl-[max(1rem,env(safe-area-inset-left))] pr-[max(1rem,env(safe-area-inset-right))] md:pl-[max(1.5rem,env(safe-area-inset-left))] md:pr-[max(1.5rem,env(safe-area-inset-right))] lg:px-8">
          {children}
        </main>
      </div>
      <BottomTabBar />
    </div>
  );
}
